import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const fakeCursorForToolbarPluginKey = new PluginKey('fakeCursorToolbarPlugin');
